import styled from 'styled-components';
import { Table, Typography } from 'antd';
import { FONT_SIZE, FONT_WEIGHT, BREAKPOINTS } from '../../styles/themes/constants';
import { Link } from 'react-router-dom';

export const H1 = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: 16px;
    font-size: ${FONT_SIZE.xxxxl};
    color: #1a1a2e;
    font-weight: 700;
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 28px;
      margin-bottom: 12px;
    }
    
    @media (max-width: ${BREAKPOINTS.sm}px) {
      font-size: 24px;
    }
  }
`;

export const H2 = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: 16px;
    margin-top: 24px;
    font-size: ${FONT_SIZE.xxxl};
    color: #1a1a2e;
    font-weight: 600;
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 20px;
      margin-bottom: 12px;
      margin-top: 20px;
    }
    
    @media (max-width: ${BREAKPOINTS.sm}px) {
      font-size: 18px;
    }
  }
`;

export const H5 = styled(Typography.Title)`
  &.ant-typography {
    margin-bottom: 10px;
    padding-top: 20px;
    font-size: ${FONT_SIZE.md};
    color: #434343;
    font-weight: 600;
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 15px;
      padding-top: 16px;
    }
  }
`;

export const Paragraph = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 16px;
    font-size: ${FONT_SIZE.xs};
    line-height: 1.7;
    color: #434343;
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 12px;
    }
  }
`;

export const ContentRight = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 10px;
    text-align: end;
    font-size: ${FONT_SIZE.xs};
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 14px;
      text-align: left;
    }
  }
`;

export const ContentLeft = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 10px;
    font-size: ${FONT_SIZE.xs};
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 14px;
    }
  }
`;

export const Span = styled.span`
  color: var(--text-main-color);
  font-size: ${FONT_SIZE.xs};
  font-weight: ${FONT_WEIGHT.bold};
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    font-size: 14px;
  }
`;

export const Tab = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 0;
    padding-left: 20px;
    font-size: ${FONT_SIZE.xs};
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 14px;
      padding-left: 16px;
    }
  }
`;

export const TabEnd = styled(Typography.Paragraph)`
  &.ant-typography {
    margin-bottom: 0;
    padding-left: 20px;
    padding-bottom: 20px;
    font-size: ${FONT_SIZE.xs};
    
    @media (max-width: ${BREAKPOINTS.md}px) {
      font-size: 14px;
      padding-left: 16px;
      padding-bottom: 16px;
    }
  }
`;

export const TextLink = styled(Link)`
  color: #1677ff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  
  &:hover {
    color: #0958d9;
    text-decoration: underline;
  }
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    font-size: 14px;
  }
`;

// Additional mobile-friendly components
export const ContentWrapper = styled.div`
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 0;
  }
`;

export const Section = styled.section`
  margin-bottom: 32px;
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    margin-bottom: 24px;
  }
`;

export const LinkCard = styled.div`
  display: block;
  padding: 16px 20px;
  background: #fafafa;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f0f5ff;
    border-color: #91caff;
    transform: translateX(4px);
  }
  
  h4 {
    margin: 0 0 8px 0;
    color: #1677ff;
    font-weight: 600;
    font-size: 16px;
  }
  
  p {
    margin: 0;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
  }
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 14px 16px;
    
    h4 {
      font-size: 15px;
    }
    
    p {
      font-size: 13px;
    }
  }
`;

export const List = styled.ul`
  margin: 16px 0;
  padding-left: 24px;
  
  li {
    margin-bottom: 8px;
    line-height: 1.6;
    color: #434343;
    font-size: ${FONT_SIZE.xs};
  }
  
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding-left: 20px;
    
    li {
      font-size: 14px;
    }
  }
`;